import { DateFormatter } from '@repo/toolkit/date'

import { MissionStatusEnum } from '../../types/enums/mission/mission-status.enum'
import { MissionTypeEnum } from '../../types/enums/mission/mission-type.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { MissionFilter } from '../../types/models/mission/mission-filter'

export const transformMissionFiltersToUrl = (filters?: MissionFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.periods && filters.periods.length > 0)
    searchParams.set('periods', filters.periods.join(','))

  if (filters.missionDate) searchParams.append('missionDate', filters.missionDate)
  if (filters.status) searchParams.append('status', filters.status)
  if (filters.type) searchParams.append('type', filters.type)
  if (filters.meetingPlaceIds && filters.meetingPlaceIds.length > 0)
    searchParams.append('meetingPlaceIds', filters.meetingPlaceIds.join(','))
  if (filters.departurePlaceId)
    searchParams.append('departurePlaceId', filters.departurePlaceId.toString())
  if (filters.arrivalPlaceId)
    searchParams.append('arrivalPlaceId', filters.arrivalPlaceId.toString())
  if (filters.qualifications && filters.qualifications.length > 0)
    searchParams.append('qualifications', filters.qualifications.join(','))

  return searchParams.toString()
}

export const transformUrlToMissionFilters = (searchParams: URLSearchParams): MissionFilter => {
  const filters: MissionFilter = {}

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',')

  const missionDate = DateFormatter.checkDateFormat(searchParams.get('missionDate'))
  if (missionDate) filters.missionDate = missionDate

  const status = searchParams.get('status')
  if (status) filters.status = status as MissionStatusEnum

  const type = searchParams.get('type')
  if (type) filters.type = type as MissionTypeEnum

  const meetingPlaceIds = searchParams.get('meetingPlaceIds')
  if (meetingPlaceIds) filters.meetingPlaceIds = meetingPlaceIds.split(',').map(Number)

  const departurePlaceId = searchParams.get('departurePlaceId')
  if (departurePlaceId) filters.departurePlaceId = parseInt(departurePlaceId)

  const arrivalPlaceId = searchParams.get('arrivalPlaceId')
  if (arrivalPlaceId) filters.arrivalPlaceId = parseInt(arrivalPlaceId)

  const qualifications = searchParams.get('qualifications')
  if (qualifications)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  return filters
}
